export class URIComponentEncoder {
  encodeName(key) {
    return encodeURIComponent(String(key));
  }
  encodeValue(value) {
    return encodeURIComponent(String(value));
  }
}
